import ManualPage from './ManualPage'
import { receptionManual } from './manualContent'

export default function ReceptionManualPage() {
  return <ManualPage content={receptionManual} />
}
